import {
  images,
  tags,
  progressBars,
  buttonsDefault,
  buttonsFilled,
  buttonsHollow,
  startProgressBars
} from './elements.js';

/**
 * LAYOUT DA ABA ELEMENTOS
 *
 * A composição abaixo separa as duas colunas inferiores em fluxos próprios:
 * - Tags ocupa a coluna esquerda;
 * - Progress e os grupos de botões empilham independentemente na direita.
 *
 * Isso evita que a altura do catálogo de Tags infle as linhas dos fieldsets
 * da coluna direita.
 */
const buttonsSoft = buttonsDefault.map((button) => ({
  ...button,
  mode: 'soft'
}));

const rightColumn = {
  element: 'group',
  type: 'fieldset',
  style: { width: '100%' },
  cols: 1,
  groups: [
    {
      legend: 'Progress e Meter',
      isGrid: true,
      content: progressBars
    },
    {
      legend: 'Botões Soft',
      class: 'ep-equal-button-group',
      isGrid: true,
      content: buttonsSoft
    },
    {
      legend: 'Botões Filled',
      class: 'ep-equal-button-group',
      isGrid: true,
      content: buttonsFilled
    },
    {
      legend: 'Botões Hollow',
      class: 'ep-equal-button-group',
      isGrid: true,
      content: buttonsHollow
    }
  ]
};

const elementsLayout = {
  element: 'group',
  type: 'fieldset',
  style: { width: '1600px' },
  cols: 5,
  groups: [
    {
      legend: 'Imagens',
      row: 0,
      col: 0,
      colspan: 5,
      cols: 4,
      isGrid: true,
      content: images
    },
    {
      legend: 'Tags',
      row: 1,
      col: 0,
      colspan: 2,
      isGrid: true,
      content: tags
    },
    {
      type: 'out-section',
      row: 1,
      col: 2,
      colspan: 3,
      isGrid: true,
      content: [rightColumn]
    }
  ]
};

export { startProgressBars };
export default elementsLayout;
